/* eslint-disable react/jsx-no-target-blank */
/**
 * @file 基本布局
 * @author cuibolun(cuibolun@baijia.com)
 * @date 2020-01-01
 */
import React, {Dispatch, useEffect, useState, createContext} from 'react';
import {Popover} from 'antd';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {PageFooter} from '@yunying/crow';
import Header from '~/component/Header';
import HeaderMobile from '~/component/HeaderMobile';
import HomeFooter from '~/component/HomeFooter';
import FooterMobile from '~/component/FooterMobile';

import './index.less';

const WINDOW_WIDTH = 768;


type BasicLayoutContextProps = {
    isMobile?: boolean;
}
export const BasicLayoutContext = createContext<BasicLayoutContextProps>({});

interface Props {
    children: React.ReactNode;
    user: any;
    dispatch: Dispatch<any>;
}
function BasicLayout(props) {
    const {children, location: {pathname}} = props;
    const hasHeaderPage = pathname.indexOf('/html') === -1;
    const {clientWidth} = document.documentElement;
    const isMobilePhone = clientWidth <= WINDOW_WIDTH;
    const [isMobile, setIsMobile] = useState(isMobilePhone);

    function onResize() {
        if (document.documentElement.clientWidth <= WINDOW_WIDTH) {
            setIsMobile(true);
        }
        else {
            setIsMobile(false);
        }
    }

    useEffect(() => {
        window.addEventListener('resize', onResize);
        return () => {
            window.removeEventListener('resize', onResize);
        };
    }, []);


    return (
        <BasicLayoutContext.Provider value={{isMobile}}>
            <div>
                {
                    isMobile && hasHeaderPage && (
                        <HeaderMobile />
                    )
                }
                {
                    !isMobile && hasHeaderPage && <Header pathname={pathname} />
                }

                <main>
                    {children}
                </main>
                <div className="footer-page">
                    {
                        hasHeaderPage && (
                            <>
                                <HomeFooter />
                                {
                                    isMobile
                                        ? (
                                            <FooterMobile />
                                        )
                                        : (
                                            <div className="footer-and-icon">
                                                <div className="footer-icon">
                                                    <PageFooter
                                                        copyright="Gaotu Techedu Inc. Copyright Beijing ICP 1406 1840"
                                                    />
                                                    <div className="footer-icon-info">
                                                        <Popover content="Linkedin">
                                                            <a href="https://www.linkedin.com/company/gaotu/mycompany/?viewAsMember=true" target="_blank">
                                                                <img
                                                                    className="info-icon"
                                                                    src="//i.gsxcdn.com/1324509445_aq6txm3l.png"
                                                                    alt="linkedin"
                                                                />
                                                            </a>
                                                        </Popover>
                                                        <Popover content="Twitter">
                                                            <a href="https://twitter.com/gotu_ir" target="_blank">
                                                                <img
                                                                    className="info-icon"
                                                                    src="//i.gsxcdn.com/1324509446_zljrrkg4.png"
                                                                    alt="tw"
                                                                />
                                                            </a>
                                                        </Popover>
                                                        <Popover content="Futu">
                                                            <a href="https://q.futunn.com/profile/40000062?lang_code=0" target="_blank">
                                                                <img
                                                                    className="info-icon"
                                                                    src="//i.gsxcdn.com/1366875754_ewx67cmg.png"
                                                                    alt="ft"
                                                                />
                                                            </a>
                                                        </Popover>
                                                        <Popover content="Tiger">
                                                            <a href="https://www.laohu8.com/personal/3536273629510539" target="_blank">
                                                                <img
                                                                    className="info-icon"
                                                                    src="//i.gsxcdn.com/1366875755_q0kp0dix.png"
                                                                    alt="lh"
                                                                />
                                                            </a>
                                                        </Popover>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                }
                            </>
                        )
                    }

                </div>
            </div>
        </BasicLayoutContext.Provider>
    );
}

BasicLayout.propTypes = {
    history: PropTypes.shape({
        goBack: PropTypes.func.isRequired
    }).isRequired,
    children: PropTypes.node.isRequired,
    routeConfig: PropTypes.shape({}).isRequired
};


export default connect(({user}: any) => ({user}))(BasicLayout);
